module.exports = __webpack_public_path__ + "static/media/golf-ball.73f2e9b5.svg";